<template>
  <div v-if="eventosWeb" class="container-fluid">
    <Home />
  </div>
</template>

<style>
.custom-background {
    background-color: #fff;
}
</style>

<script>
import { globales } from "../components/comunes"

const web = "kutxabank.cms"

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Cabecera from '@/components/plantilla/Cabecera.vue'
import Menu from '@/components/plantilla/Menu.vue'
import Slider from '@/components/plantilla/Slider.vue'
import Home from '@/components/plantilla/Inicio.vue'
import Paginas from '@/components/plantilla/Paginas.vue'

export default {
  name: 'home',
  mixins: [globales],
  components: {
    Cabecera,
    Menu,
    Slider,
    Home,
    Paginas
  }
}
</script>
